import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, output, Signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CountryCode } from 'src/app/shared/interfaces/IHelpItemCountryAddOn';

@Component({
  selector: 'app-header-search-link',
  imports: [RouterLink, TranslateModule, NgTemplateOutlet],
  templateUrl: './header-search-link.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header-search-link.component.scss'
})
export class HeaderSearchLinkComponent {
  public readonly title = input.required<string>();
  public readonly icon = input.required<string>();
  public readonly chevron = input<'left' | 'right' | 'down' | 'up'>('right');
  public readonly link = input<string>();
  public readonly subtitle = input<string>('');
  public readonly countries = input<CountryCode[]>([]);
  public readonly clicked = output<void>();

  protected countryFlagLinks: Signal<{ country: CountryCode; flagUrl: string }[]> = computed(() =>
    this.countries().map(countryCode => {
      return {
        country: countryCode,
        flagUrl: `/assets/svgs/flags/${countryCode.toLowerCase()}.svg`
      };
    })
  );
}
